module.exports = __webpack_public_path__ + "pc/img/scene1.94b1416d.png";